const footerES = {
	tagline: "La forma más simple de reservar — y de recibir reservas. Creada en la República Dominicana para los negocios que la mueven.",
	columns: {
		company: "Empresa",
		legal: "Legal",
		getApp: "Descarga la app",
	},
	links: {
		about: "Sobre Nosotros",
		privacy: "Política de Privacidad",
		terms: "Términos de Servicio",
		contact: "Contacto",
		refundPolicy: "Política de Reembolso",
	},
	apps: {
		note: "Las apps para iOS y Android vienen en camino.",
		soon: "Pronto",
		appStoreAria: "Descárgalo en App Store",
		appStoreSmall: "Descárgalo en",
		appStoreName: "App Store",
		googlePlayAria: "Disponible en Google Play",
		googlePlaySmall: "Disponible en",
		googlePlayName: "Google Play",
	},
	/* Elementos compartidos de las páginas legales */
	legal: {
		eyebrow: "Legal",
		contents: "Contenido",
		backToTop: "Volver arriba",
	},
	socialsLabel: "Sigue a Sin Fila",
	languageSwitch: "English",
	madeInDR: "Orgullosamente creada y registrada en la República Dominicana",
	rights: "Todos los derechos reservados.",
};

export default footerES;
